module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-10.7e08feba.png";